module.exports = __webpack_public_path__ + "f.no1.f5898a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/f.no1.jpg
// module id = tAjX
// module chunks = 0